import { getTravellerFormSchemaRequestKey } from './request/travellerSchema'

const getCheckoutTravellerSchema = (state: App.State) => state.checkout.schemaData[getTravellerFormSchemaRequestKey(state)]

export function isCheckoutTravellerSchemaReady(
  schemaData: App.Checkout.TravellerFormSchemaData | null | undefined,
  isFetchingSchema: boolean,
  isFormInitialised: boolean,
): boolean {
  return !!schemaData?.accommodationFlightSchema && !isFetchingSchema && isFormInitialised
}

export function isCheckoutTravellerReadinessSatisfied({
  checkoutNeedsTravellerForms,
  shouldShowTravellerForm,
  schemaData,
  isFetchingSchema,
  isFormInitialised,
}: {
  checkoutNeedsTravellerForms: boolean
  shouldShowTravellerForm: boolean
  schemaData: App.Checkout.TravellerFormSchemaData | null | undefined
  isFetchingSchema: boolean
  isFormInitialised: boolean
}): boolean {
  if (!checkoutNeedsTravellerForms) {
    return true
  }

  if (!shouldShowTravellerForm) {
    return false
  }

  return isCheckoutTravellerSchemaReady(schemaData, isFetchingSchema, isFormInitialised)
}

export default getCheckoutTravellerSchema
